"use strict";
/* eslint-disable */
/* This file has been generated with `npm run generate-types` */
Object.defineProperty(exports, "__esModule", { value: true });
exports.config = void 0;
exports.config = {
    dev0: {
        id: 8995,
        name: 'dev0',
        nativeCurrency: {
            symbol: 'DEV',
            name: 'Developer Ethereum',
            decimals: 18,
        },
        rpcEndpoints: [
            { url: 'http://10.200.10.1:8545' },
            { url: 'ws://10.200.10.1:8545' },
        ],
        contracts: {
            AMB: '0xaFA0dc5Ad21796C9106a36D68f69aAD69994BB64',
            DATA: '0xbAA81A0179015bE47Ad439566374F2Bae098686F',
            DataUnionFactory: '0x90a0480c6fA6b2dC967d8F03660c81C8a5A7c465',
            DataUnionTemplate: '0x07a4CaF6064ACFe4c279e32e5ed2F376B36DcB3F',
            DefaultFeeOracle: '0x454E0fEcCf4611eA9E41C986E4A2949CFD4b53d4',
            ENS: '0x92E8435EB56fD01BF4C79B66d47AC1A94338BB03',
            FIFSRegistrar: '0x57B81a9442805f88c4617B506206531e72d96290',
            Marketplace: '0xF1371c0f40528406dc4f4cAf89924eA9Da49E866',
            MarketplaceV3: '0x56e57Bf7422eDe1ED75520D4387829feEe8a8319',
            MigrationManager: '0xc7aaf6c62e86a36395d8108fe95d5f758794c16c',
            PublicResolver: '0xBc0c81a318D57ae54dA28DE69184A9c3aE9a1e1c',
            TokenMediator: '0xedD2aa644a6843F2e5133Fe3d6BD3F4080d97D9F',
            TrackerRegistry: '0xBFCF120a8fD17670536f1B27D9737B775b2FD4CF',
            Uniswap2Router: '0xeE1bC9a7BFF1fFD913f4c97B6177D47E804E1920',
            UniswapAdapter: '0xE4eA76e830a659282368cA2e7E4d18C4AE52D8B3',
            Uniswap2AdapterForMarketplaceV3: '0xDbcdfB708A006A9AebC592C4520289cD87a95938',
            XDATA: '0x6d0F3bF9aD2455b4F62f22fFD21317e1E3eEFE5C',
            'core-api': '0xFCAd0B19bB29D4674531d6f115237E16AfCE377c',
        },
    },
    dev1: {
        id: 8997,
        name: 'dev1',
        nativeCurrency: {
            symbol: 'DEV',
            name: 'Developer Ethereum',
            decimals: 18,
        },
        rpcEndpoints: [
            { url: 'http://10.200.10.1:8546' },
            { url: 'ws://10.200.10.1:8546' },
        ],
        contracts: {
            AMB: '0xaFA0dc5Ad21796C9106a36D68f69aAD69994BB64',
            DATA: '0x73Be21733CC5D08e1a14Ea9a399fb27DB3BEf8fF',
            DataUnionFactory: '0x50aAa135AeBAC61E8394F80fF2Df091fcb66b072',
            DefaultFeeOracle: '0xd1FA6C06E1D838Bb989640A2C4b8a499FD0ab187',
            DataUnionTemplate: '0xC2F87E37019e227F2Be5030aabBCc7eAF136e05c',
            LINK: '0x3387F44140ea19100232873a5aAf9E46608c791E',
            Marketplace: '0xa072C42CB167d68D4c1cA15d0e4d0bd93E74A80f',
            MarketplaceV3: '0xA90CeCcA042312b8f2e8B924C04Ce62516CBF7b2',
            MarketplaceV4: '0xB9372284e0D61607aF3B7EF5f022e7D599Ed2a37',
            ProjectRegistryV1: '0x3C841B9Aa08166e9B864972930703e878d25804B',
            ProjectStakingV1: '0xBFCF120a8fD17670536f1B27D9737B775b2FD4CF',
            Mediator: '0xedD2aa644a6843F2e5133Fe3d6BD3F4080d97D9F',
            StorageNodeRegistry: '0x231b810D98702782963472e1D60a25496999E75D',
            StreamRegistry: '0x6cCdd5d866ea766f6DF5965aA98DeCCD629ff222',
            ENSCacheV2: '0x611900fD07BB133016Ed85553aF9586771da5ff9',
            StreamStorageRegistry: '0xd04af489677001444280366Dd0885B03dAaDe71D',
            Uniswap2Router: '0xdc5F6368cd31330adC259386e78604a5E29E9415',
            StreamrConfig: '0xa86863053cECFD9f6f861e0Fd39a042238411b75',
            SponsorshipFactory: '0x58C8e321d561123649bE41445cB0690Ec3d27Fe9',
            SponsorshipDefaultLeavePolicy: '0xa2338F8be0941B361baBebb01ab8da5725CF0a33',
            SponsorshipMaxOperatorsJoinPolicy: '0x2521E0480004056c35e199a1BBE2FdA9119032A0',
            SponsorshipOperatorContractOnlyJoinPolicy: '0xd8F0a63e5EB661695620c92af5d981D18d5a484E',
            SponsorshipStakeWeightedAllocationPolicy: '0xef927F18D2ac3862c6ABCAa953203A4DbF7f519e',
            SponsorshipVoteKickPolicy: '0x0617466e5bC15027c604A56E35b172E06d689E4f',
            OperatorFactory: '0xcb5bCb343218044C547AFdcBa2e50Ac728D0DcA3',
            OperatorDefaultDelegationPolicy: '0x03CF38C75BFb9F4466fBA0aEd95f2613B0D1bCA0',
            OperatorDefaultUndelegationPolicy: '0x67A0E9C9c21d11dB4eBAe420aBf705626a3a2561',
            OperatorDefaultExchangeRatePolicy: '0x252743660fACD52e7CEF851CEB1c133B58Fb526d',
        },
        theGraphUrl: 'http://10.200.10.1:8000/subgraphs/name/streamr-dev/network-subgraphs',
    },
    dev2: {
        id: 31337,
        name: 'dev2',
        nativeCurrency: {
            symbol: 'DEV',
            name: 'Developer Ethereum',
            decimals: 18,
        },
        rpcEndpoints: [{ url: 'http://10.200.10.1:8547' }],
        adminPrivateKey: '0x5e98cce00cff5dea6b454889f359a4ec06b9fa6b88e9d69b86de8e1c81887da0',
        contracts: {
            DATA: '0xbAA81A0179015bE47Ad439566374F2Bae098686F',
            ENS: '0xEAA002f7Dc60178B6103f8617Be45a9D3df659B6',
            FIFSRegistrar: '0xF1371c0f40528406dc4f4cAf89924eA9Da49E866',
            PublicResolver: '0xdc5F6368cd31330adC259386e78604a5E29E9415',
            TrackerRegistry: '0xE4eA76e830a659282368cA2e7E4d18C4AE52D8B3',
            StorageNodeRegistry: '0x338090C5492C5c5E41a4458f5FC4b205cbc54A24',
            StreamRegistry: '0x18E0937099660B82464475Ea2B7e6Af4f2BFE5F0',
            ENSCacheV2: '0x7739b57beC285539A62434DF9808f66ebB405ba3',
            StreamStorageRegistry: '0xB73189CeBCc870bE6f9aa16764bbB3665e4B49B6',
            StreamrConfig: '0x00E680d549FE53a627a3db86a6F88fA2471CFfAa',
            SponsorshipOperatorContractOnlyJoinPolicy: '0xB9372284e0D61607aF3B7EF5f022e7D599Ed2a37',
            SponsorshipMaxOperatorsJoinPolicy: '0x36368Be8Cde49558Ab6ceEf2632984b282Db8775',
            SponsorshipStakeWeightedAllocationPolicy: '0xc24BA8c05E5206F1bE57bfA0aD14E9882126eD38',
            SponsorshipDefaultLeavePolicy: '0xBFCF120a8fD17670536f1B27D9737B775b2FD4CF',
            SponsorshipVoteKickPolicy: '0x92E8435EB56fD01BF4C79B66d47AC1A94338BB03',
            SponsorshipFactory: '0x699B4bE95614f017Bb622e427d3232837Cc814E6',
            OperatorDefaultDelegationPolicy: '0x5159FBF2e0Ff63e35b17293416fdf7a0909a0cDA',
            OperatorDefaultExchangeRatePolicy: '0xfC31c70FafCbFe399195C789602ae2455B247fD2',
            OperatorDefaultUndelegationPolicy: '0xBacF06448F4f14361AD80d425686021b041F3B2C',
            OperatorFactory: '0xD13D34d37e2c94cb35EA8D5DE7498Cb7830d26e0',
            ProjectRegistryV1: '0xA9166376706611110f814D1333b8E80FEc5d8f10',
            MarketplaceV4: '0xb8678223183d560280a7BEF68daAbB0E3daBd97D',
            ProjectStakingV1: '0x73a9310C43621B853C508902bb8c1DA8f1240EaE',
        },
        theGraphUrl: 'http://10.200.10.1:8800/subgraphs/name/streamr-dev/network-subgraphs',
        entryPoints: [
            {
                nodeId: 'eeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee',
                websocket: { host: '10.200.10.1', port: 40500, tls: false },
            },
        ],
    },
    alfajores: {
        id: 44787,
        name: 'Celo Alfajores',
        nativeCurrency: {
            symbol: 'CELO',
            name: 'Celo Alfajores',
            decimals: 18,
        },
        rpcEndpoints: [{ url: 'https://alfajores-forno.celo-testnet.org' }],
        contracts: {
            ProjectRegistryV1: '0x32A142A27A595DC75aD1443728fecCbD5650446A',
            MarketplaceV4: '0x14577e0D5BD77536E073712d98E471edDaFAE8b4',
            cUSD: '0x874069Fa1Eb16D44d622F2e0Ca25eeA172369bC1',
        },
        blockExplorerUrl: 'https://alfajores.celoscan.io',
    },
    optGoerli: {
        id: 420,
        name: 'Optimism Goerli Testnet',
        nativeCurrency: {
            symbol: 'ETH',
            name: 'Optimism Goerli Testnet Ethereum',
            decimals: 18,
        },
        rpcEndpoints: [{ url: 'https://goerli.optimism.io' }],
        contracts: {
            RemoteMarketplaceV1: '0xBef916b1EC6EAA3F522368f75094DAed5c228aF6',
            DAI: '0xDA10009cBd5D07dd0CeCc66161FC93D7c9000da1',
        },
        blockExplorerUrl: 'https://goerli-optimism.etherscan.io',
    },
    ethereum: {
        id: 1,
        name: 'Ethereum',
        nativeCurrency: { symbol: 'ETH', name: 'Ethereum', decimals: 18 },
        rpcEndpoints: [],
        contracts: {
            AMB: '0x4C36d2919e407f0Cc2Ee3c993ccF8ac26d9CE64e',
            DATA: '0x8f693ca8D21b157107184d29D398A8D082b38b76',
            ENS: '0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e',
            Marketplace: '0xdc8d23092b93f9bb7416f45dea36f55996f34867',
            MediatorDATA: '0x29e572d45cC33D5a68DCc8f92bfc7ded0017Bc59',
            MediatorXDATA: '0x2eeeDdeECe91c9F4c5bA4C8E1d784A0234C6d015',
            MigrationManager: '0xf32219E61c840300D1B35c939ed9E54a86163334',
            TrackerRegistry: '0xab9BEb0e8B106078c953CcAB4D6bF9142BeF854d',
            UniswapAdapter: '0xbe99db4ea1964ea9a9e80de41517901da6ef9307',
            XDATA: '0x0cf0ee63788a0849fe5297f3407f701e122cc023',
            'core-api': '0xf3E5A65851C3779f468c9EcB32E6f25D9D68601a',
        },
        blockExplorerUrl: 'https://etherscan.io',
    },
    gnosis: {
        id: 100,
        name: 'Gnosis Chain',
        nativeCurrency: { symbol: 'xDAI', name: 'xDai', decimals: 18 },
        rpcEndpoints: [
            { url: 'https://rpc.gnosischain.com' },
            { url: 'wss://rpc.gnosischain.com/wss' },
        ],
        contracts: {
            AMB: '0x75Df5AF045d91108662D8080fD1FEFAd6aA0bb59',
            BinanceAdapterDATA: '0x193888692673b5dD46e6BC90bA8cBFeDa515c8C1',
            BinanceAdapterXDATA: '0x0c1aF6edA561fbDA48E9A7B1Dd46D216F31A97cC',
            DATA: '0x256eb8a51f382650B2A1e946b8811953640ee47D',
            DataUnionFactory: '0xe4515702878931b45Dfe4D89d3Fb3208910C913C',
            DataUnionTemplate: '0x1d425525c7A5df3736875fe76Bc3B9E776E89AcA',
            DataUnionFeeOracle: '0x86686266E7cA80b247151104f26d308079997637',
            Marketplace: '0x246dd6D96282c1ED9Ca69eF9f3e1f975fC1B8Bd5',
            MarketplaceV3: '0x2022E1F7749D355726Fb65285E29605A098bcb52',
            MediatorDATA: '0x53f3F44c434494da73EC44a6E8a8D091332bC2ce',
            MediatorXDATA: '0x7d55f9981d4E10A193314E001b96f72FCc901e40',
            MigrationManager: '0x29e572d45cC33D5a68DCc8f92bfc7ded0017Bc59',
            RemoteMarketplaceV1: '0x023eaE17d3dd65F1e7b4daa355e6478719Bd2BEf',
            StorageNodeRegistry: '0xC746847d7916623fb75849696f04827bbc34854f',
            UniswapAdapter: '0xc5Cd4900841a849d798725441b54fB0fec0d0f5b',
            Uniswap2AdapterForMarketplaceV3: '0xec92c5f94d45D1a4D917f2E07dD959b33e1AFe38',
            XDATA: '0xE4a2620edE1058D61BEe5F45F6414314fdf10548',
        },
        blockExplorerUrl: 'https://gnosisscan.io',
    },
    binance: {
        id: 56,
        name: 'BNB Chain',
        nativeCurrency: { symbol: 'BNB', name: 'BNB', decimals: 18 },
        rpcEndpoints: [
            { url: 'https://bsc-dataseed.binance.org' },
            { url: 'wss://bsc-dataseed.binance.org' },
        ],
        contracts: {
            DATA: '0x0864c156b3c5f69824564dec60c629ae6401bf2a',
            xdaiBridge: '0xa93ee7b4a7215f7e725437a6b6d7a4e7fe1dd8f0',
        },
        blockExplorerUrl: 'https://bscscan.com',
    },
    polygon: {
        id: 137,
        name: 'Polygon',
        nativeCurrency: { symbol: 'MATIC', name: 'MATIC', decimals: 18 },
        rpcEndpoints: [
            { url: 'https://polygon-rpc.com' },
            { url: 'https://polygon.drpc.org' },
            { url: 'https://rpc-mainnet.matic.quiknode.pro' },
            { url: 'https://polygon-bor-rpc.publicnode.com' },
        ],
        contracts: {
            ChainlinkOracle: '0x36BF71D0ba2e449fc14f9C4cF51468948E4ED27D',
            DATA: '0x3a9A81d576d83FF21f26f325066054540720fC34',
            DataUnionFactory: '0xd0B3a09A6bCee8446d10e6E7e12c78F8725C9B18',
            DataUnionTemplate: '0xaFe97F5a1cD3edE2c11d990e0EB0270054AA0589',
            DataUnionFeeOracle: '0x369Be397b3Cfe914728Bbd2329c0e5D1FE2E4202',
            GSNPayMaster: '0x43E69adABC664617EB9C5E19413a335e9cd4A243',
            GSNForwarder: '0xdA78a11FD57aF7be2eDD804840eA7f4c2A38801d',
            ENSCache: '0xEd9d3D29c25e197677DD84E3f7D81cCCD613B2bF',
            ENSCacheV2: '0xEd9d3D29c25e197677DD84E3f7D81cCCD613B2bF',
            Marketplace: '0x058FbB3Cf628EE51CE8864C9Ee8350f81E495A7D',
            MarketplaceV3: '0x1e9c22B4C92ce78Fe489C72f9D070C583D8359C3',
            MarketplaceV4: '0xdF8b74D735197dCD5C94bE933db080E69A958de6',
            ProjectRegistryV1: '0x496a6154da5aA6a021a3bd0DCd337DA80F48a6e1',
            ProjectStakingV1: '0xAA7a4BdBE91F143F3103206e48A8AfF21101B6DE',
            StorageNodeRegistry: '0x080F34fec2bc33928999Ea9e39ADc798bEF3E0d6',
            StreamRegistry: '0x0D483E10612F327FC11965Fc82E90dC19b141641',
            StreamStorageRegistry: '0xe8e2660CeDf2a59C917a5ED05B72df4146b58399',
            StreamrConfig: '0x869e88dB146ECAF20dDf199a12684cD80c263c8f',
            SponsorshipOperatorContractOnlyJoinPolicy: '0xa1F3c94A682Cb43d26AcC40dA1Dc31f49e4dA466',
            SponsorshipMaxOperatorsJoinPolicy: '0x27448061420bAccAE8c84DDC3E7e2e8B2aE4977E',
            SponsorshipStakeWeightedAllocationPolicy: '0x1Dd16E748308E9f259f3D6097d00e1793BfBdcDB',
            SponsorshipDefaultLeavePolicy: '0xa953D590098A3d56304a12A8e929D63748D90AAC',
            SponsorshipVoteKickPolicy: '0xeF3F567D7328849c1130CBCBF8Cd9feB42eA5dB5',
            SponsorshipFactory: '0x820b2f9a15ed45F9802c59d0CC77C22C81755e45',
            OperatorDefaultDelegationPolicy: '0x8e449F0B1AFAD807135B5Ea829F41851d5DE1426',
            OperatorDefaultExchangeRatePolicy: '0xE8F511bB4888D16D81acab7ab1c05A356E37237f',
            OperatorDefaultUndelegationPolicy: '0x5c81fA1e79318386Dd82Ef059bCB194DbA87De45',
            OperatorFactory: '0x935734e66729b69260543Cf6e5EfeB42AC962183',
            Uniswap2Router: '0xa5E0829CaCEd8fFDD4De3c43696c57F7D7A678ff',
            UniswapAdapter: '0xAd54A57383EcA2D4f0D22337A96A7c4f6Bd51A13',
            Uniswap2AdapterForMarketplaceV3: '0x83C42F77c6dD09A1A93A7834be65b3bB891106bE',
        },
        blockExplorerUrl: 'https://polygonscan.com',
        theGraphUrl: 'https://gateway-arbitrum.network.thegraph.com/api/a971cec07440a9ec63cd806c06ccc990/subgraphs/id/EGWFdhhiWypDuz22Uy7b3F69E9MEkyfU9iAQMttkH5Rj',
        entryPoints: [
            {
                nodeId: 'e5f87a7ee99b3c91e7b795b70f87ef8ba5497596',
                websocket: {
                    host: 'polygon-entrypoint-3.streamr.network',
                    port: 443,
                    tls: true,
                },
            },
            {
                nodeId: '6f5b53812fd9cc07f225a0b3a6aa5b96672e852e',
                websocket: {
                    host: 'polygon-entrypoint-4.streamr.network',
                    port: 443,
                    tls: true,
                },
            },
        ],
    },
    polygonAmoy: {
        id: 80002,
        name: 'Polygon Amoy testnet',
        nativeCurrency: { symbol: 'MATIC', name: 'Amoy MATIC', decimals: 18 },
        rpcEndpoints: [
            { url: 'https://polygon-amoy-bor-rpc.publicnode.com' },
            { url: 'https://rpc-amoy.polygon.technology' },
        ],
        contracts: {
            DATA: '0xf5e28a2E7BbedbE97c3782b17b102410E10d90f1',
            StreamRegistry: '0xE9C98bdE63248e58E9137Db8270D9675B9E34b93',
            ENSCacheV2: '0x6a81414936868fdcF4f077e2a0B24879e2871016',
            StorageNodeRegistry: '0x02fdF917f4e6Ae8F7F1bBDd28179d819E2b76820',
            StreamStorageRegistry: '0x0f3671A9A92416E1aD32750faCf2AD4FA1b66f78',
            StreamrConfig: '0x835bC97D2a61bbF5d05932C5105Ca34e1b815F94',
            SponsorshipOperatorContractOnlyJoinPolicy: '0x930Dcc2ca313ACf7177185C0D68462fDc699C7e0',
            SponsorshipMaxOperatorsJoinPolicy: '0xd640C2C5102953d122759826daa6Aec25eC98ca5',
            SponsorshipStakeWeightedAllocationPolicy: '0xaC80c738FCF8d259F07C82eAD68B75aF4DF82223',
            SponsorshipDefaultLeavePolicy: '0x16Ba0F2793Da54b67717c6bAD471624C6628F2aa',
            SponsorshipVoteKickPolicy: '0xA73aDbEC14be2D3628CeAD022243f080CB162955',
            SponsorshipFactory: '0xb194a68b166f2e3074B551393fA61490D19c69f8',
            OperatorDefaultDelegationPolicy: '0x78f29fF290148e83795393f1858DC540D8cB046b',
            OperatorDefaultExchangeRatePolicy: '0x48d25dd5731AD644613b67E4281C505Ef392Dd70',
            OperatorDefaultUndelegationPolicy: '0x7962155D5ea2fF949FCF300F221964d5ef9d1bad',
            OperatorFactory: '0xE02E8E9fF5ea6a58F34D00C0e4B091e066B9fA81',
            ProjectRegistryV1: '0xc5e1434d35c0c7291c7032Fd9C4096b4876C6823',
            ProjectStakingV1: '0x3A27A16770477EbcFb4B81cE462F4f12591767A0',
            MarketplaceV4: '0x6C8eaA8e0bF605469c15b6F9106387B4cEC99976',
            DataUnionFactory: '0x62d48EBcf518AF1eb4c647721a19B046810623c4',
            DataUnionTemplate: '0xACe6B50B1d1Fb06b4650eF4Adb094747C65Ab674',
            DataUnionFeeOracle: '0x1A20217419156E09D36fd380d3F429d03AD2Dc97',
        },
        theGraphUrl: 'https://gateway.thegraph.com/api/dd2dd773d33a3b2f5028ddaa8e1874c1/subgraphs/id/3nVH84bDz3wFJ82UZxMD2WfpGyU2KzDnZdEdDQFsHAqp',
        blockExplorerUrl: 'https://amoy.polygonscan.com',
        entryPoints: [
            {
                nodeId: 'd48787fc36eaed43770ec84947ef81557b19ec98',
                websocket: {
                    host: 'amoy-entrypoint-1.streamr.network',
                    port: 443,
                    tls: true,
                },
            },
            {
                nodeId: '24395826687b099fd735a730219ba750169c4f40',
                websocket: {
                    host: 'amoy-entrypoint-2.streamr.network',
                    port: 443,
                    tls: true,
                },
            },
        ],
    },
    peaq: {
        id: 3338,
        name: 'Peaq EVM chain',
        nativeCurrency: { symbol: 'PEAQ', name: 'PEAQ', decimals: 18 },
        rpcEndpoints: [{ url: 'https://peaq.api.onfinality.io/public' }],
        contracts: {
            DATA: '0xdCB1EcdD509c61De5C3B672fDD2335AC750142c9',
            StreamRegistry: '0xD0C720e99Bd39311614f292d8B0B4e351Bde157c',
            ENSCacheV2: '0x4A71d0FA9e3326E830048B1423d7010fB9343071',
            StorageNodeRegistry: '0xaCF9e8134047eDc671162D9404BF63a587435bAa',
            StreamStorageRegistry: '0xB36CF8ee4219a3Ac9FBC3865C35E9a99353c26db',
            StreamrConfig: '0xc81Fa3Cc3E81dF24D21bfc608f8FB06262Da4F8c',
            SponsorshipOperatorContractOnlyJoinPolicy: '0xF655955dc561356851e95a6D0febeB0BAc955Ab5',
            SponsorshipMaxOperatorsJoinPolicy: '0xE41439BF434F9CfBF0153f5231C205d4ae0C22e3',
            SponsorshipStakeWeightedAllocationPolicy: '0xC8E8efAF4CE7bCcFc87878631BC64A1FAe63dc5D',
            SponsorshipDefaultLeavePolicy: '0xDa579a9a55158Bc57389f1b05F553DEf38a121c1',
            SponsorshipVoteKickPolicy: '0xdc8d23092b93F9BB7416F45dEa36f55996f34867',
            SponsorshipFactory: '0xdaF0905e19C45b9Fea7E60D232061edF78E9F570',
            OperatorDefaultDelegationPolicy: '0xD3329a2FC8194f0F96749275FF5162f7f2F031F7',
            OperatorDefaultExchangeRatePolicy: '0xA3D82B569ab0dEF86935fCf4e7714626a608CF81',
            OperatorDefaultUndelegationPolicy: '0x3EF89eF888721446Cf373C5070399B8225C9E936',
            OperatorFactory: '0x6d201374D7c28EF1c3cc1b6FA300f06110B597A3',
            ProjectRegistryV1: '0xB14205AE3D7672B937B972EBdf2b986fB0B8CfaA',
            ProjectStakingV1: '0xd1cBD6b1Be710C41c01A9613802209843407b8b9',
            MarketplaceV4: '0x959684926448296ea72BD4B05593426A3cD3F0dF',
        },
        blockExplorerUrl: 'https://peaq.subscan.io',
        theGraphUrl: 'https://gateway.thegraph.com/api/5bcf7b0d11045c944600d4007737d457/subgraphs/id/CV3grB3fYpUzET1s75kXG2BaNyREK5uRA8SkjLTyXXh7',
        entryPoints: [
            {
                nodeId: 'e5f87a7ee99b3c91e7b795b70f87ef8ba5497596',
                websocket: {
                    host: 'polygon-entrypoint-3.streamr.network',
                    port: 443,
                    tls: true,
                },
            },
            {
                nodeId: '6f5b53812fd9cc07f225a0b3a6aa5b96672e852e',
                websocket: {
                    host: 'polygon-entrypoint-4.streamr.network',
                    port: 443,
                    tls: true,
                },
            },
        ],
    },
    iotex: {
        id: 4689,
        name: 'IoTeX',
        nativeCurrency: { symbol: 'IOTX', name: 'IOTX', decimals: 18 },
        rpcEndpoints: [{ url: 'https://babel-api.mainnet.iotex.one' }],
        contracts: {
            DATA: '0xD94be6fd546d4cE502CB1E870A58330Cc8869e9B',
            StreamRegistry: '0x080F34fec2bc33928999Ea9e39ADc798bEF3E0d6',
            ENSCacheV2: '0xAB072849dd3Cd648cb85c73d525a70A36523337d',
            StorageNodeRegistry: '0xb9e70Bd9833dd091f06edc8073aa86a76EdeF46D',
            StreamStorageRegistry: '0xF79c40Fbc432f1f8B8B017441B644e0ac7bccea2',
            StreamrConfig: '0x176B108E72ee49A01Bea1eDb32f7f296d2bb3db8',
            SponsorshipOperatorContractOnlyJoinPolicy: '0xace5b2A71A44efD9259983b5671d8ba802703dF7',
            SponsorshipMaxOperatorsJoinPolicy: '0x6956abe11F99e3983282f8B4fFb30015cC45Ae1D',
            SponsorshipStakeWeightedAllocationPolicy: '0x0Eb81BF75e585B227c01BBd1Ba5Ee0Ab6b1b55d5',
            SponsorshipDefaultLeavePolicy: '0xb9fe5430aC3eE3B1D26734C513f41Bf96B10C830',
            SponsorshipVoteKickPolicy: '0xc4a1ba0655FC6C34F9283e33682e57031fC060af',
            SponsorshipFactory: '0x7ac03730374E995E366F2a466be6aCC14E1DB1C4',
            OperatorDefaultDelegationPolicy: '0x5E0F361EC38cBE990baCB0D3008B5582DA4eAa2a',
            OperatorDefaultExchangeRatePolicy: '0x75e26741538825263954AC2a1Ad9d6eAb695FD47',
            OperatorDefaultUndelegationPolicy: '0x6D48ee54898e9B1f5FBe468ab85eA542dd82Ae6c',
            OperatorFactory: '0xD1Bc2A37405F88d4904844B7BF1BEadA7c0851c1',
            ProjectRegistryV1: '0xbb2a2CF40Ca86378983cfcACB7Aac1568237a692',
            MarketplaceV4: '0xe3F6750a5f9a6315cB11adc5CE980F7356C927C4',
            ProjectStakingV1: '0x0F91Edc1760e64e434Fb9CaF93a76b262E7015b3',
        },
        blockExplorerUrl: 'https://iotexscan.io',
        theGraphUrl: 'https://gateway.thegraph.com/api/4bddc6e1e1fe65a49bf8091785478835/subgraphs/id/CvGQcfBwWH1SvyxJDGjRRMa4YXQpxmpt369orMirZ3RH',
        entryPoints: [
            {
                nodeId: 'e5f87a7ee99b3c91e7b795b70f87ef8ba5497596',
                websocket: {
                    host: 'polygon-entrypoint-3.streamr.network',
                    port: 443,
                    tls: true,
                },
            },
            {
                nodeId: '6f5b53812fd9cc07f225a0b3a6aa5b96672e852e',
                websocket: {
                    host: 'polygon-entrypoint-4.streamr.network',
                    port: 443,
                    tls: true,
                },
            },
        ],
    },
    iotexTestnet: {
        id: 4690,
        name: 'IoTeX Testnet',
        nativeCurrency: { symbol: 'IOTEX', name: 'IOTEX', decimals: 18 },
        rpcEndpoints: [{ url: 'https://babel-api.testnet.iotex.io' }],
        contracts: {
            DATA: '0x5ABD469031d2B5f939808565EAB8562d7Cbaa939',
            StreamRegistry: '0xDC695780959aa5aEe9B28dfED7332032e3045210',
            ENSCacheV2: '0xDDf8FB60f8c3ffb1C20375A30f6D8CFB0C48Bd38',
            StorageNodeRegistry: '0xc0F9666fbF16B2ac5726697237BcdF79096e3FA7',
            StreamStorageRegistry: '0xd0C3A69762Bd920C1cAfBE91612a4600429f02f1',
            StreamrConfig: '0x6d201374D7c28EF1c3cc1b6FA300f06110B597A3',
            SponsorshipOperatorContractOnlyJoinPolicy: '0xAd24077505d3584F1AC8d78719F9d31F7Da0E264',
            SponsorshipMaxOperatorsJoinPolicy: '0x78d13aaBA657F448933Bb469E4E549Dee88cB78B',
            SponsorshipStakeWeightedAllocationPolicy: '0xB14205AE3D7672B937B972EBdf2b986fB0B8CfaA',
            SponsorshipDefaultLeavePolicy: '0xfC9C1886EAd9a757039Edbee16Bea0183344D2BA',
            SponsorshipVoteKickPolicy: '0xd1cBD6b1Be710C41c01A9613802209843407b8b9',
            SponsorshipFactory: '0x84c8d8f9760639e159350e5d2Bfaada99b670114',
            OperatorDefaultDelegationPolicy: '0x67352e3F7dBA907aF877020aE7E9450C0029C70c',
            OperatorDefaultExchangeRatePolicy: '0xE41439BF434F9CfBF0153f5231C205d4ae0C22e3',
            OperatorDefaultUndelegationPolicy: '0xF655955dc561356851e95a6D0febeB0BAc955Ab5',
            OperatorFactory: '0xdaF0905e19C45b9Fea7E60D232061edF78E9F570',
        },
        blockExplorerUrl: 'https://testnet.iotexscan.io',
        entryPoints: [],
    },
};
